import React, { useEffect } from 'react'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useLocation,
} from 'react-router-dom'
import HomeScreen from './screens/HomeScreen'
import PublicationScreen from './screens/PublicationScreen'
import TeamsScreen from './screens/TeamsScreen'
import ResourcesScreen from './screens/ResourcesScreen'
import NewsScreen from './screens/NewsScreen'
import IndividualNewsScreen from './screens/IndividualNewsScreen'
import Header from './utils/Header'
import Footer from './utils/Footer'

const ScrollToTop = () => {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])
  return null
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <main>
        <Switch>
          <Route path='/' component={HomeScreen} exact />
          <Route path='/publications' component={PublicationScreen} exact />
          <Route path='/team' component={TeamsScreen} exact />
          <Route path='/resources' component={ResourcesScreen} exact />
          <Route path='/news' component={NewsScreen} exact />
          <Route path='/news/:id' component={IndividualNewsScreen} exact />
        </Switch>
      </main>
      <Footer />
    </Router>
  )
}

export default App
